---
title: Registry
description: Learn how to use the audio/ui Registry with shadcn/ui.
---

The audio/ui registry adds audio components and blocks to a shadcn/ui project. Add the namespace once, then install any item by name.

## Setup

Add the `@audio-ui` namespace to your `components.json` once: [Installation](/docs/get-started#setup-the-audioui-registry) has the line, and the prerequisites.

## Usage

Install blocks via the shadcn CLI using the `@audio-ui/{name}` syntax.

```bash
npx shadcn@latest add @audio-ui/block-pocket-synth
```

Install components via the shadcn CLI using the `@audio-ui/{name}` syntax.

```bash
npx shadcn@latest add @audio-ui/knob
```
